'use strict';
import YearNav from '../components/YearNav/YearNav.vue';

const mixin = {
  components: { YearNav },
  props: {
    hideYearNav: {
      type: Boolean
    },
  },
  data() {
    return {
      currentYear: this.year || this.$store.state.currentYear
    };
  },
  mounted() {
    console.log('eui-yearnav-mixin');
  },
  computed: {

  },
  methods: {
    changeYear(year) {
      console.log('changeYear', this, year);
      this.currentYear = year;
    }
  },
  watch: {
    currentYear(year, oldYear) {
      console.log('foo', year, oldYear);

      if (year !== oldYear) {
        console.log('asdfgf', this.name);
        this.$store.dispatch('LOAD_RESULTS', {
          year,
          from: this.name
        });
      }
    }
  }
};

export default mixin;
